import React from 'react';
import './_sequenceLoader.scss';

const SequenceLoader = ({ progress }) => {
  return (
    <div className="sequenceLoader">
      <div className="sequenceLoader__spinner">
        <svg viewBox="0 0 44 44" className="sequenceLoader__svg">
          {/* Cercle de fond */}
          <circle
            className="sequenceLoader__track"
            cx="22" cy="22" r="18"
            fill="none"
            strokeWidth="3"
          />
          {/* Cercle de progression */}
          <circle
            className="sequenceLoader__progress"
            cx="22" cy="22" r="18"
            fill="none"
            strokeWidth="3"
            strokeDasharray={`${2 * Math.PI * 18}`}
            strokeDashoffset={`${2 * Math.PI * 18 * (1 - progress / 100)}`}
            strokeLinecap="round"
          />
        </svg>
        <span className="sequenceLoader__percent">{progress}%</span>
      </div>
      <p className="sequenceLoader__label">Chargement de la séquence…</p>
    </div>
  );
};

export default SequenceLoader;
